import React, { useEffect, useState } from "react";
import { Container, makeStyles } from "@material-ui/core";
import Page from "components/Page";
import { Header } from "components";
import serviciosCatalogo from "utils/serviciosCatalogo";
import CuerpoCatalogo from "./Components/CuerpoCatalogo";
import getErrorMessage from "utils/getErrorMessage";
import { useForm } from "react-hook-form";
import Formulario from "./Components/FormModulo";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const Modulo = ({ permisos }) => {
  const classes = useStyles();
  const { register, errors, handleSubmit, control } = useForm();
  const [data, setData] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const [modal, setModal] = useState({ open: false });
  const [ctl, setCtl] = useState({ rol: [], proyecto: [] });
  const [mAdvertencia, setMAdvertencia] = useState({ open: false });
  const cambioEstatusFila = (item) => (event) => {
    clickBaja(event.target.checked)([item])();
  };
  const servicios = {
    get: () =>
      serviciosCatalogo.modulosAll((res) => {
        setData(res.data);
        setCtl({ proyectos: res.proyectos });
      }, setCargando),
    insert: (data) =>
      serviciosCatalogo.moduloCreate(respuesta(cerrarModal), setCargando, data),
    update: (data) =>
      serviciosCatalogo.moduloUpdate(respuesta(cerrarModal), setCargando, data),
    baja: (data) =>
      serviciosCatalogo.moduloDown(respuesta(cerrarModal), setCargando, data),
  };

  const clickBaja = (estatus) => (seleccionados) => () =>
    setMAdvertencia({
      open: true,
      paddingDisabled: false,
      titulo: "Advertencia",
      mensaje:
        seleccionados.length > 0
          ? seleccionados.length +
            " Elementos seleccionados serán dados de " +
            (estatus ? "alta" : "baja") +
            ", ¿Está seguro de continuar?"
          : seleccionados.length +
            " Elemento seleccionado será dado de " +
            (estatus ? "alta" : "baja") +
            ", ¿Está seguro de continuar?",
      aceptar: () =>
        servicios.baja({
          estatus: estatus,
          ids: seleccionados.map((i) => i["idmodulo"]),
        }),
    });

  const cerrarModal = () => setModal({ open: false });
  const cerrarAdvertencia = () => setMAdvertencia({ open: false });
  const respuesta = (onSuccess) => (status, mensaje, data) => {
    if (status > 0) {
      onSuccess();
      setData(data);
    }
    setMensaje({ open: true, status: status, value: mensaje });
    cerrarAdvertencia();
  };
  const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });
  const columns = [
    { label: "SISTEMA", name: "nproyecto", filtrar: true },
    { label: "MODULO", name: "nmodulo", filtrar: true },
    { label: "ESTATUS", name: "nestatus", filtrar: true },
    {
      label: "ESTATUS",
      name: "idestatus",
      filtrar: true,
      type: { type: "check", accion: cambioEstatusFila, active: "1" },
    },
  ];

  useEffect(() => {
    servicios.get(setData, setCargando);
  }, []);
  return (
    <Page
      className={classes.root}
      title="Usuarios"
      mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
      cargando={cargando}
    >
      <Container maxWidth={false}>
        <Header title="CATÁLOGO" subtitle="MODULOS" />
        <CuerpoCatalogo
          keyTabla="catModulo"
          servicios={servicios}
          permisos={permisos}
          columns={columns}
          data={data}
          id="idmodulo"
          modal={modal}
          catalogo="MODULO"
          setModal={setModal}
          mAdvertencia={mAdvertencia}
          setMAdvertencia={setMAdvertencia}
          handleSubmit={handleSubmit}
          form={
            <Formulario
              control={control}
              register={register}
              errors={getErrorMessage(errors)}
              catalogo={ctl.proyectos}
              defaultItem={modal.item || {}}
            />
          }
        />
      </Container>
    </Page>
  );
};

export default Modulo;
